export default {
  footer: state => state.app.footer,
  huilv: state => state.app.huilv,
  homeActive: state => state.app.homeActive,
  home: state => state.app.home,
  token: state => state.app.token,
  kf: state => state.app.kf,
  view: state => state.app.view,
  fwq: state => state.app.fwq,
  isLogin: state => !!state.app.token,
  backgroundColor: state => state.app.backgroundColor,
  userInfo: state => state.app.userInfo || {},
  storeItems: state => state.app.storeItems || {},
  goName: state => state.app.goName
};

